/********************************************************
 * Card used to display a carton order of graphic design
 * order in the cart. 🐺
 * **********************
 * @format */

import {ConvertQuoteToNewOrderButton} from '../../../account/components/shared/convert_quote_to_new_order_button';
import ModalPortal, {ModalClose} from 'frontier-admin/modal/container_portal';
import {OrderDisplayMeta} from '../cart_overview/chunks/order_display_meta';
import {ORDER_STATUS_QUOTE, PRODUCT_TYPE_LABEL} from 'frontier-constants';
import {ConditionalButton, IfElse, withUploadHandler} from 'frontier-utilities';
import {prettyProductLabel} from '../../../ds/quoter/functions/format';
import QuoteLoginModal from 'frontier/ds/quoter/quote_login_modal';
import {Icon, Button, Modal, ModalHeader, ModalFooter} from '@sttark/design-system';
import {AccountContext} from 'frontier-utilities';
import NumberFormat from 'react-number-format';
import NumberInputField from './form/number_input_field';
import React from 'react';
import {If} from 'frontier-utilities';

import {
    MODAL_SAVE_LATER,
    MODAL_EDIT,
    MODAL_UPLOAD_ARTWORK,
    MODAL_DELETE_ORDER,
    MODAL_REMOVE_FROM_CART,
    MODAL_LOGIN
} from './modal_constants';
import {PRODUCT_TYPE_GRAPHIC_DESIGN} from 'frontier-constants';

import SuperAgent from 'superagent';
import {parseEntityError} from 'frontier-form';
import dot from 'dot-object';
import {CartForm} from './form/cart_form';

// styles
import './order.sass';

const withOrderHandler = Component => {
    return class extends React.Component {
        static defaultProps = {
            designs: [],
            values: [],
            totalOrderCount: 1
        };

        static contextType = AccountContext;

        constructor(props) {
            super(props);

            this.state = {
                saving: false,
                open: false //this.props.orderIndex === 1 ? true : false
            };
        }

        handleToggle = () => {
            this.setState({open: !this.state.open});
        };

        handleSave = () => {
            this.setState({saving: true}, async () => {
                try {
                    const {
                        body: {cart}
                    } = await SuperAgent.post(`/carts/save-to-account/${this.props.id}`)
                        .set('accept', 'application/json')
                        .send({customer_label: this.props.customer_label});

                    this.props.onSavedToAccount(this.props.id);
                } catch (e) {
                    const error = parseEntityError(dot.pick('response.body', e));
                    this.setState({error, saving: false});
                }
            });
        };

        render() {
            const props = {...this.props};

            props.userContext = this.context;
            props.onToggle = this.handleToggle;
            props.onSave = this.handleSave;

            return <Component {...props} {...this.state} />;
        }
    };
};

class NewOrder extends React.Component {
    static contextType = AccountContext;
    state = {
        expanded: false,
        displaySaved: false,
        showModal: 0,
        qtyIsSaving: false
    };

    isSaving = fieldName => {
        return (
            this.props.fieldsSaving &&
            this.props.fieldsSaving.findIndex(
                x => x.orderId === this.props.id && x.fieldName === fieldName
            ) > -1
        );
    };

    handleLogin = response => {
        const {isLoggedIn} = response;
        if (isLoggedIn) {
            this.setState({showModal: 0});
            this.props.onSave();
        }
    };

    render() {
        const isGraphicDesign = this.props.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN;
        const totalQty = this.props.designs_orders.reduce((total, dos) => (total += dos.qty), 0);

        const productLabel = prettyProductLabel(
            this.props.size_description,
            this.props.product_type_id
        );

        return (
            <>
                {/*Save for later*/}
                <Modal
                    onClose={() => this.setState({showModal: 0})}
                    isOpen={this.state.showModal === MODAL_SAVE_LATER}
                    zIndex={1050}
                    bodyHeightAuto>
                    <ModalHeader onClose={() => this.setState({showModal: 0})}>
                        Save for Later
                    </ModalHeader>
                    <div>
                        <p className="mb-2 mt-0 mx-0">
                            <b>Do you wish to proceed?</b>
                        </p>
                        <p className="mt-0">
                            Saving a cart item for later adds it to the Saved Quotes page within
                            your user account page.
                        </p>
                    </div>
                    <ModalFooter>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button
                                onClick={() => this.setState({showModal: 0})}
                                label="Cancel"
                                secondary
                            />
                            <Button
                                onClick={() => {
                                    this.setState({showModal: 0});

                                    if (this.context?.user?.is_logged_in) this.props.onSave();
                                    else this.setState({showModal: MODAL_LOGIN});
                                }}
                                label="Save for Later"
                            />
                        </div>
                    </ModalFooter>
                </Modal>
                {/* Edit Modal */}
                <Modal
                    onClose={() => this.setState({showModal: 0})}
                    isOpen={
                        this.state.showModal === MODAL_EDIT ||
                        this.state.showModal === MODAL_UPLOAD_ARTWORK
                    }
                    zIndex={1050}
                    bodyHeightAuto>
                    <ModalHeader onClose={() => this.setState({showModal: 0})}>
                        {this.state.showModal === 2 ? 'Edit Item' : 'Upload Work'}
                    </ModalHeader>
                    <div>
                        <p className="mb-2 mt-0 mx-0">
                            <b>You will be taken back to the Quoter.</b>
                        </p>
                        <p className="mt-0">
                            {this.state.showModal === 2
                                ? 'From there, you can edit all details of this item. Changes to this cart item will be automatically saved and the item will be updated in the cart.'
                                : 'From there, you can upload artwork. Changes to this cart item will be automatically saved.'}
                        </p>
                    </div>
                    <ModalFooter>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button
                                onClick={() => this.setState({showModal: 0})}
                                label="Cancel"
                                secondary
                            />
                            <Button
                                onClick={() =>
                                    (window.location = `/orders/custom-${
                                        this.props.product_type_id === PRODUCT_TYPE_LABEL
                                            ? 'labels'
                                            : 'cartons'
                                    }/${this.props.id}?edit&showErrorsFromCart=true`)
                                }
                                label="Edit Item"
                            />
                        </div>
                    </ModalFooter>
                </Modal>
                {/* Delete Order */}
                <Modal
                    onClose={() => this.setState({showModal: 0})}
                    isOpen={
                        this.state.showModal === MODAL_DELETE_ORDER ||
                        this.state.showModal === MODAL_REMOVE_FROM_CART
                    }
                    zIndex={1050}
                    bodyHeightAuto>
                    <ModalHeader onClose={() => this.setState({showModal: 0})}>
                        {this.state.showModal === 4 ? 'Delete Order' : 'Remove from Cart'}
                    </ModalHeader>
                    <div>
                        <p className="mb-2 mt-0 mx-0">
                            <b>
                                {this.state.showModal === 4
                                    ? 'Do you wish to proceed?'
                                    : `You’ve set 0 quantity for ${prettyProductLabel(
                                          this.props.size_description,
                                          this.props.product_type_id
                                      )}.`}
                            </b>
                        </p>
                        <p className="mt-0">
                            {this.state.showModal === 4
                                ? 'You are about to remove an item from your cart. This action cannot be undone.'
                                : `This will remove it from your cart. Are you sure you want to do this?`}
                        </p>
                    </div>
                    <ModalFooter>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button
                                onClick={() => this.setState({showModal: 0})}
                                label="Cancel"
                                secondary
                            />
                            <Button
                                onClick={() => {
                                    this.setState({showModal: 0});
                                    this.props.onDelete();
                                }}
                                label={this.state.showModal === 4 ? 'Delete' : 'Remove'}
                                destructive
                            />
                        </div>
                    </ModalFooter>
                </Modal>
                {/* Login Modal */}
                {this.state.showModal === MODAL_LOGIN && (
                    <ModalPortal
                        onClose={() => this.setState({showModal: 0})}
                        noCard={true}
                        maxWidth="700px">
                        <div style={{background: 'white', padding: '20px', position: 'relative'}}>
                            <ModalClose onClose={() => this.setState({showModal: 0})} />
                            <QuoteLoginModal
                                orderId={this.props.id}
                                defaultLabel={this.props.customer_label}
                                onLogin={this.handleLogin}
                                onShowCreateAccount={() => {}}
                            />
                        </div>
                    </ModalPortal>
                )}
                <div
                    className={
                        this.props.orderStatus === ORDER_STATUS_QUOTE
                            ? 'cart-order order-incomplete'
                            : 'cart-order'
                    }>
                    {this.props.orderStatus === ORDER_STATUS_QUOTE && (
                        <div>
                            <h5 className="founders-sb error-header">
                                Incomplete Order. Please complete your order to checkout
                            </h5>
                            <a
                                href={
                                    '/orders/custom-labels/' +
                                    this.props.id +
                                    '?edit&showErrorsFromCart=true'
                                }
                                className="btn btn-sm btn-complete">
                                Complete Order
                            </a>
                        </div>
                    )}

                    {/*** order container starts ***/}
                    <div
                        className={`order-container d-flex align-items-center justify-content-center
                        ${
                            this.props.orderStatus === ORDER_STATUS_QUOTE
                                ? 'cart-order order-incomplete'
                                : 'cart-order'
                        }
                        `}>
                        <div className="order-container_card  rounded">
                            {/*order detials: major card container */}
                            <div className="cart-order-container">
                                <div className="cart-order-details d-flex align-items-center">
                                    {/* design preview */}
                                    {this.props.designs_orders.length > 0 && (
                                        <IfElse condition={this.props.is_blank}>
                                            <div className="text-nowrap tw-pr-4">Blank Design</div>
                                            <div
                                                className={`designs-contianer${
                                                    this.props.designs_orders.length < 2
                                                        ? '--no-designs'
                                                        : ''
                                                }`}>
                                                <div
                                                    className="designs carton-label--designs"
                                                    style={{
                                                        backgroundImage: `url(${this.props.designs_orders[0].signed_url})`
                                                    }}>
                                                    {this.props.designs_orders.length > 1 && (
                                                        <p className="designs_count text-center color-content-darkest m-0 text-start">
                                                            + {this.props.designs_orders.length - 1}{' '}
                                                            designs
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </IfElse>
                                    )}

                                    {/* order item header Mobile only*/}
                                    <div className="item-meta-header--mobile bg-structure-lightest mt-0 mx-0 mb-4 w-100 border-bottom border-dark ">
                                        <h6 className="m-0 ps-3">item</h6>
                                    </div>

                                    {/* order meta */}
                                    <div className="product-meta mx-0 mt-0 mb-auto">
                                        {/*title: Item size and type */}
                                        <div className="item-title-container mx-0 mt-0 mb-2">
                                            <h3 className="m-0 text-left tw-p-0 product_size-label">
                                                {productLabel}
                                            </h3>
                                            <ConditionalButton enabled={this.props.is_reorder}>
                                                <ConvertQuoteToNewOrderButton id={this.props.id}>
                                                    <button className="ms-3 me-0 my-0 tw-p-0 d-flex align-items-center justify-content-center gap-1 color-accent-primary">
                                                        <i className="fas fa-copy" />
                                                        <u>Edit as New Order</u>
                                                    </button>
                                                </ConvertQuoteToNewOrderButton>
                                                <button
                                                    className="btn--primary py-0 px-3 product-meta_edit"
                                                    onClick={() => this.setState({showModal: 2})}>
                                                    Edit
                                                </button>
                                            </ConditionalButton>
                                            {this.props.is_reorder && (
                                                <span className="badge text-bg-info tw-ml-2 mr-2">
                                                    Reorder
                                                </span>
                                            )}
                                        </div>

                                        {/* order display meta */}
                                        <OrderDisplayMeta props={this.props} />

                                        {/*order controls */}
                                        <div className="mx-0 mt-0 mb-2 d-flex align-items-center justify-content-start cart-order-controls">
                                            <button
                                                className="cart-order-controls_control tw-p-0 d-flex align-items-center justify-content-start"
                                                onClick={() =>
                                                    this.setState({
                                                        expanded: !this.state.expanded
                                                    })
                                                }>
                                                <Icon name="view" small color="black" />
                                                <span>View All Details</span>
                                            </button>
                                            <ConditionalButton enabled={this.props.saving}>
                                                <button
                                                    className="btn btn-sm tw-p-0"
                                                    disabled="disabled">
                                                    <i
                                                        className="fa fa-spin fa-spinner"
                                                        style={{marginRight: '10px'}}
                                                    />
                                                </button>
                                                <button
                                                    className="m-0 tw-p-0 cart-order-controls_control d-flex align-items-center justify-content-start"
                                                    onClick={() => this.setState({showModal: 1})}>
                                                    <i
                                                        className="fa fa-save"
                                                        style={{marginRight: '3px'}}
                                                    />
                                                    <Icon name="save" small color="black" />
                                                    <span>Save for Later</span>
                                                </button>
                                            </ConditionalButton>
                                        </div>
                                    </div>

                                    {/* item totals header. Mobile only*/}
                                    <div className="item-total-header--mobile bg-structure-lightest mt-5 mx-0 mb-4 w-100 border-bottom border-dark ">
                                        <h6 className="m-0">Qty</h6>
                                        <h6 className="m-0">Unit</h6>
                                        <h6 className="m-0">Subtotal</h6>
                                    </div>

                                    {/* order qty */}
                                    <div className="product-qty align-self-start">
                                        <div className="cart-order-qty">
                                            <NumberInputField
                                                style={{lineHeight: '16px'}}
                                                isEditable={false}
                                                value={this.props.duplex_aware_total_qty}
                                                numberFormatProps={{
                                                    decimalScale: 0,
                                                    fixedDecimalScale: true,
                                                    thousandSeparator: true
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* price per unit*/}
                                    <div className="cart-order-unit align-self-start">
                                        <p className="cart-order-unit_price tw-p-0 m-0">
                                            ${' '}
                                            {Math.ceil(
                                                ((this.props.quoted_total -
                                                    this.props.quoted_die_charge) /
                                                    this.props.duplex_aware_total_qty) *
                                                    1000
                                            ) / 1000}{' '}
                                        </p>
                                    </div>

                                    {/*order subtotal*/}
                                    <h5 className="cart-order-subtotal align-self-start">
                                        <NumberFormat
                                            displayType={'text'}
                                            value={
                                                this.props.orderStatus === ORDER_STATUS_QUOTE
                                                    ? 0.0
                                                    : this.props.quoted_total
                                            }
                                            prefix={'$'}
                                            decimalScale={0}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                        />
                                    </h5>
                                </div>
                                {/* number of design and shipping estimate */}
                                <div className="cart-order_footer d-flex align-items-center justify-content-between">
                                    {this.props.designs_orders.length >= 2 ? (
                                        <p className="designs_qty-placeholder"></p>
                                    ) : (
                                        <p className="m-0 designs_qty-placeholder text-end"></p>
                                    )}

                                    <p className="m-0 designs_qty-placeholder text-end"></p>
                                </div>
                                {/*if missing artwork*/}
                                {this.props.designs_orders.length === 0 && (
                                    <div className="designs_missing_design d-flex align-items-center justify-content-start">
                                        <p className="m-0">
                                            <span>
                                                <Icon name="warning" color="#e5b200" small />
                                            </span>
                                            You still need to
                                        </p>
                                        <h5
                                            className="color-action-primary m-0"
                                            onClick={() => this.setState({showModal: 3})}>
                                            upload artwork.
                                        </h5>
                                    </div>
                                )}

                                {/* order call to actions. mobile only*/}
                                <div className="cart-order_cta-container--mobile">
                                    {!this.props.is_reorder && (
                                        <Button
                                            className="edit-button--mobile w-100 mt-4 mb-4"
                                            label={'Edit'}
                                            primary
                                            onClick={() => this.setState({showModal: 2})}
                                        />
                                    )}

                                    <div className="cart-order_cta--mobile w-100 mb-4 d-block">
                                        <h6
                                            className="text-center my-0 m-auto"
                                            onClick={() =>
                                                this.setState({
                                                    expanded: !this.state.expanded
                                                })
                                            }>
                                            View All Details
                                        </h6>
                                    </div>
                                    <div className="cart-order_cta--mobile w-100  mb-4 d-block">
                                        <h6
                                            className="text-center my-0 m-auto"
                                            onClick={() => this.setState({showModal: 1})}>
                                            Save for Later
                                        </h6>
                                    </div>
                                    <div className="cart-order_cta--mobile w-100  mb-4 d-block">
                                        <h6
                                            className="text-center my-0 m-auto color-alert-negative"
                                            onClick={() => this.setState({showModal: 4})}>
                                            Delete
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Delete */}
                        <div className="order-contianer_delete tw-p-0">
                            {this.isSaving('deleting') && (
                                <span>
                                    <i className={'fa fa-spinner fa-spin'} />
                                </span>
                            )}

                            {!this.isSaving('deleting') && (
                                <button
                                    className="delete_icon m-0 b-0"
                                    onClick={() => this.setState({showModal: 4})}>
                                    <Icon name="trash" color="#df3d33" />
                                </button>
                            )}
                        </div>
                    </div>

                    {/* order details modal */}
                    {this.state.expanded && (
                        <CartForm
                            cta={{
                                handleClose: () => this.setState({expanded: !this.state.expanded})
                            }}
                            cart={{
                                ...this.props,
                                totalQty: totalQty,
                                isSaving: this.isSaving
                            }}
                        />
                    )}
                    {/* leaving until resolving if we are adding it again */}
                    {/*<DropOverlay dropping={this.props.dropping} />*/}
                    {/*{!this.state.expanded && <ExpediteButton {...this.props} />}*/}
                </div>
            </>
        );
    }
}
export default withOrderHandler(withUploadHandler(NewOrder));
